import { render } from "./XUserBox.vue?vue&type=template&id=145a5b2a&scoped=true"
import script from "./XUserBox.vue?vue&type=script&lang=js"
export * from "./XUserBox.vue?vue&type=script&lang=js"

import "./XUserBox.vue?vue&type=style&index=0&id=145a5b2a&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145a5b2a"]])

export default __exports__